import { render, staticRenderFns } from "./layananKesehatan.vue?vue&type=template&id=79fc867a&"
import script from "./layananKesehatan.vue?vue&type=script&lang=js&"
export * from "./layananKesehatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QInput,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QInput,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
